import { NoddiCircularLoaderWithTrans } from '../Loading/NoddiCircularLoaderWithTrans';

export const ScreenLoader = () => (
  <div className='flex min-h-screen justify-center'>
    <NoddiCircularLoaderWithTrans />
  </div>
);
